import {
	requests
}from "../../../../api/agent"

export default {
	create          : (params) => requests.post('/ReRegion/create', params),
	update          : (params) => requests.post('/ReRegion/update', params),
	delete          : (params) => requests.getWithParams('/ReRegion/delete', params),
	restore         : (params) => requests.getWithParams('/ReRegion/restore', params),
	getPaged        : (params) => requests.getWithParams('/ReRegion/getPaged', params),
	getPagedAll     : (params) => requests.getWithParams('/ReRegion/getPagedAll', params),
	getList         : (params) => requests.getWithParams('/ReRegion/getList', params),
	getListForRoles : (params) => requests.getWithParams('/ReRegion/getListForRoles', params),
	getPagedAudit   : (params) => requests.getWithParams('/ReRegion/getPagedAudit', params)
}